<agm-marker
  [title]="poi.title"
  [latitude]="poi.place.position.latitude"
  [longitude]="poi.place.position.longitude"
  [agmFitBounds]="true"
  [label]="index"
  ><agm-info-window *ngIf="poi.title" [maxWidth]="300">
    <h3 style="text-align: center; margin-top: 5px;">{{ poi.title }}</h3>
    <p *ngIf="poi.image">
      <img
        [src]="sanitizeImageUrl(poi.image.url)"
        style="max-width: 100%; max-height:200px; margin: 0 auto; display: block;"
      />
    </p>
    <p *ngIf="poi.description" style="text-align: justify">
      {{ poi.description }}
    </p>
    <p style="text-align: center; margin-bottom: 5px;">
      <a
        mat-raised-button
        color="primary"
        [href]="getPoiGoogleMapsUrl(poi)"
        target="_blank"
        style="font-size: 18px !important;"
      >
        <mat-icon>directions</mat-icon> Apri su Maps
      </a>
    </p>
  </agm-info-window></agm-marker
>
